import React from 'react';
import Link from 'next/link';
import { ContributorProps } from '../../types/components/shared/ContributorTypes';
import { AssetCountIcon } from '../../modules/Icons';

export const contributorClass = 'text-a-blue font-leading-22 text-[16px]';

export const Contributor: React.FC<ContributorProps> = ({ username, name, mobile, assetCount }) => {
  return (
    <>
      <div className={`${mobile && 'md:hidden'} mt-2`} cy-test-id="contributor-link">
        <Link href={`/c/${username}`} className="flex gap-1 items-center">
          <span className='font-light text-[#7F898D] text-[16px]'>by</span>
          <p className={contributorClass}>{name || `User${Math.floor(Math.random() * 1000)}`}</p>
        </Link>
        {assetCount && !mobile &&
          <div className='flex items-center gap-1 mt-1'>
            <AssetCountIcon className='fill-[#7F898D] w-[16px] h-[16px]'/>
            <p className='text-white text-[16px] font-light ml-1'>{assetCount} assets</p>
          </div>
        }
      </div>
    </>
  );
};
